import { useValidateDelegatedAdminInvitationTokenQuery } from 'graphql/generated/hasura';
import { useLocation, useNavigate } from 'react-router-dom';
import queryString from 'query-string';
import { AUTH_ADMIN_TOKEN_EXPIRED } from 'utilities/routes';

export const useValidateSignupToken = () => {
  const { search } = useLocation();
  const navigate = useNavigate();
  const { token, email } = queryString.parse(search);

  useValidateDelegatedAdminInvitationTokenQuery({
    variables: {
      token: (token ?? '') as string,
      email: (email ?? '') as string,
    },
    onCompleted: (data) => {
      const { isValid } = data?.validateDelegatedAdminInvitationToken ?? {};
      if (!isValid) {
        return navigate(AUTH_ADMIN_TOKEN_EXPIRED);
      }
    },
    onError: (error: Error) => {
      console.error(error);
      return navigate(AUTH_ADMIN_TOKEN_EXPIRED);
    },
  });
};
